import { AxiosError, AxiosInstance, AxiosResponse } from 'axios'

import { ZipcodeResponse } from 'models/interface/zipcode'

import { RetryConfig } from '../retryConfig'

const MIN_RETRYABLE_STATUS = 500

export const shouldRetryZipcodeValidation = (error: AxiosError): boolean =>
  !error.response || error.response.status >= MIN_RETRYABLE_STATUS

export const cepClient = (httpInstance: AxiosInstance) => ({
  validateZipcode: async (zipcode: string): Promise<AxiosResponse<ZipcodeResponse>> =>
    await httpInstance.get(`/api/validar-cep/${zipcode}`, {
      retryCondition: shouldRetryZipcodeValidation
    } as RetryConfig)
})
